(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-lbj-more-toggle]');
      if (!btn) return;
      const panel = btn.nextElementSibling?.hasAttribute('data-lbj-more-filters')
        ? btn.nextElementSibling
        : btn.closest('.lbj-drawer-more-section')?.querySelector('[data-lbj-more-filters]');
      if (!panel) return;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.classList.toggle('lbj-filters--hidden', expanded);
      const icon = btn.querySelector('.lbj-more-filters-toggle__icon, .lbj-drawer-more-toggle__icon');
      if (icon) icon.textContent = expanded ? '+' : '−';
    });

    document.addEventListener('change', (e) => {
      const filter = e.target.closest('[data-filter-param-name*="metal_type"], [data-filter-param-name*="metal-type"]');
      if (!filter) return;
      const checked = filter.querySelectorAll('input[type="checkbox"]:checked');
      let goldSelected = false;
      checked.forEach(cb => {
        const label = (cb.closest('label, li, .facets__input') || {}).textContent || '';
        if (label.toLowerCase().includes('gold')) goldSelected = true;
      });
      document.querySelectorAll('[data-lbj-gold-filters]').forEach(el => {
        el.classList.toggle('lbj-filters--hidden', !goldSelected);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
